(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-article"] && !Shopify.designMode) return;
  try {
    
  class BeautyArticlesCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsWrap = this.querySelector('[data-dots]');
      this.group = this.dataset.filterGroup || 'default';
      if (!this.viewport || !this.track) return;

      this.index = 0;
      this.onFilter = this.handleFilter.bind(this);
      this.onScroll = this.handleScroll.bind(this);
      this.onResize = this.handleResize.bind(this);
      this.onSelect = this.handleSelect.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.index - 1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('beauty-blog:filter', this.onFilter);
      document.addEventListener('shopify:block:select', this.onSelect);

      this.buildDots();
      this.syncArrowPos();
      this.updateUI();
    }

    disconnectedCallback() {
      this.initialized = false;
      if (this.viewport && this.onScroll) this.viewport.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onFilter) document.removeEventListener('beauty-blog:filter', this.onFilter);
      if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
    }

    slides() {
      return Array.prototype.filter.call(this.track.children, (slide) => !slide.classList.contains('is-filtered'));
    }

    visibleCount() {
      const root = this.closest('.beauty-arts') || this;
      const styles = getComputedStyle(root);
      const visible = parseFloat(styles.getPropertyValue('--bbc-visible'));
      if (visible > 0) return visible;
      const slides = parseFloat(styles.getPropertyValue('--bbc-slides'));
      const frac = parseFloat(styles.getPropertyValue('--bbc-frac')) || 0;
      return (slides > 0 ? slides : 1) + frac;
    }

    slideStep() {
      const items = this.slides();
      if (!items.length) return 0;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    pageCount() {
      const total = this.slides().length;
      const visible = this.visibleCount();
      const step = this.slideStep();
      if (total <= 1 || !step) return 1;

      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      if (maxScroll < 8) return 1;

      const fromScroll = Math.round(maxScroll / step) + 1;
      const fromVisible = Math.max(1, Math.ceil(total - visible + 1));
      return Math.max(1, Math.min(fromScroll, fromVisible, total));
    }

    maxIndex() {
      return Math.max(0, this.pageCount() - 1);
    }

    goTo(index, instant) {
      const max = this.maxIndex();
      this.index = Math.max(0, Math.min(index, max));
      const left = this.index * this.slideStep();
      this.viewport.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      this.updateUI();
    }

    handleScroll() {
      const step = this.slideStep();
      if (!step) return;
      const max = this.maxIndex();
      this.index = Math.max(0, Math.min(max, Math.round(this.viewport.scrollLeft / step)));
      this.updateUI();
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        const max = this.maxIndex();
        if (this.index > max) this.index = max;
        this.buildDots();
        this.syncArrowPos();
        this.goTo(this.index, true);
      }, 120);
    }

    handleFilter(event) {
      if ((event.detail.group || 'default') !== this.group) return;
      const tag = (event.detail.tag || '').toLowerCase();
      Array.prototype.forEach.call(this.track.children, (slide) => {
        const tags = (slide.dataset.tags || '').toLowerCase();
        const match = !tag || (' ' + tags + ' ').indexOf(' ' + tag + ' ') !== -1;
        slide.classList.toggle('is-filtered', !match);
      });
      this.buildDots();
      this.goTo(0, true);
    }

    handleSelect(event) {
      const slide = event.target.closest('[data-slide]');
      if (!slide || !this.contains(slide)) return;
      const items = this.slides();
      const index = items.indexOf(slide);
      if (index >= 0) this.goTo(Math.min(index, this.maxIndex()));
    }

    buildDots() {
      if (!this.dotsWrap) return;
      const count = this.pageCount();
      this.dotsWrap.innerHTML = '';
      if (count <= 1) {
        this.dotsWrap.hidden = true;
        return;
      }
      this.dotsWrap.hidden = false;
      for (let i = 0; i < count; i += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'beauty-arts__dot';
        button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        button.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(button);
      }
    }

    syncArrowPos() {
      const pos = this.dataset.arrowPos || 'center';
      const offsetY = parseFloat(this.dataset.arrowOffsetY) || 0;
      const slide = this.querySelector('.beauty-arts__slide:not(.is-filtered)');
      const media = slide ? slide.querySelector('.beauty-arts__media') : null;
      const half = this.prevButton ? this.prevButton.offsetHeight / 2 : 20;
      let y = 90;

      if (pos === 'image' && media) {
        y = media.offsetHeight / 2;
      } else if (pos === 'top') {
        y = half + 8;
      } else if (pos === 'bottom' && slide) {
        y = slide.offsetHeight - half - 8;
      } else if (slide) {
        y = slide.offsetHeight / 2;
      } else if (this.viewport) {
        y = this.viewport.offsetHeight / 2;
      }

      this.style.setProperty('--bbc-arrow-top', y + offsetY + 'px');
    }

    updateUI() {
      const max = this.maxIndex();
      const canScroll = max > 0;
      if (this.prevButton) {
        this.prevButton.disabled = this.index <= 0;
        this.prevButton.hidden = !canScroll;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.index >= max;
        this.nextButton.hidden = !canScroll;
      }
      if (!this.dotsWrap) return;
      const dots = this.dotsWrap.querySelectorAll('.beauty-arts__dot');
      dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('beauty-articles-carousel')) {
    customElements.define('beauty-articles-carousel', BeautyArticlesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scrollActivePills() {
      document.querySelectorAll('.beauty-cats__pills').forEach(function (scroller) {
        var active = scroller.querySelector('.beauty-cats__pill.is-active');
        if (!active || typeof active.scrollIntoView !== 'function') return;
        active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollActivePills);
    } else {
      scrollActivePills();
    }
    document.addEventListener('shopify:section:load', scrollActivePills);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_RETURNING = 'jw_returning_visitor';
    var STORAGE_NEW_SESSION = 'jw_new_visitor_session';
    var PREFIX = 'jw_popup_';

    function qs(root, sel) {
      return root.querySelector(sel);
    }

    function qsa(root, sel) {
      return Array.prototype.slice.call(root.querySelectorAll(sel));
    }

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }

    function setCookie(name, value, days) {
      var maxAge = days ? days * 24 * 60 * 60 : 60 * 60 * 24 * 365;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    function markReturningVisitor() {
      try {
        if (!sessionStorage.getItem(STORAGE_NEW_SESSION) && !getCookie(STORAGE_RETURNING) && !localStorage.getItem(STORAGE_RETURNING)) {
          sessionStorage.setItem(STORAGE_NEW_SESSION, '1');
        }
        if (!getCookie(STORAGE_RETURNING)) setCookie(STORAGE_RETURNING, '1', 365);
        if (!localStorage.getItem(STORAGE_RETURNING)) localStorage.setItem(STORAGE_RETURNING, String(Date.now()));
      } catch (e) {}
    }

    function isNewVisitor() {
      try {
        if (sessionStorage.getItem(STORAGE_NEW_SESSION) === '1') return true;
        return !getCookie(STORAGE_RETURNING) && !localStorage.getItem(STORAGE_RETURNING);
      } catch (e) {
        return !getCookie(STORAGE_RETURNING);
      }
    }

    function parseDate(value, endOfDay) {
      if (!value) return null;
      var s = String(value).trim();
      if (!s) return null;
      var y;
      var m;
      var d;
      var h = 0;
      var min = 0;
      var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
      var de = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{2}):(\d{2}))?/);
      if (iso) {
        y = +iso[1];
        m = +iso[2];
        d = +iso[3];
        h = iso[4] ? +iso[4] : 0;
        min = iso[5] ? +iso[5] : 0;
      } else if (de) {
        d = +de[1];
        m = +de[2];
        y = +de[3];
        h = de[4] ? +de[4] : 0;
        min = de[5] ? +de[5] : 0;
      } else {
        var fallback = new Date(s);
        return isNaN(fallback.getTime()) ? null : fallback;
      }
      if (endOfDay && !/[T ]\d{2}:\d{2}/.test(s)) {
        return new Date(y, m - 1, d, 23, 59, 59, 999);
      }
      return new Date(y, m - 1, d, h, min, 0, 0);
    }

    function inDateRange(fromValue, untilValue) {
      var now = new Date();
      var from = parseDate(fromValue, false);
      var until = parseDate(untilValue, true);
      if (from && now < from) return false;
      if (until && now > until) return false;
      return true;
    }

    function escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function normalizePath(path) {
      if (!path) return '/';
      var p = path.trim();
      if (p.charAt(0) !== '/') p = '/' + p;
      if (p.length > 1 && p.slice(-1) === '/') p = p.slice(0, -1);
      return p;
    }

    function pathMatches(pattern, pathname) {
      var pat = pattern.trim();
      if (!pat) return false;
      var path = normalizePath(pathname);
      pat = normalizePath(pat);
      if (pat.slice(-2) === '/*') {
        var base = pat.slice(0, -2);
        if (!base) return true;
        return path === base || path.indexOf(base + '/') === 0;
      }
      if (pat.indexOf('*') !== -1) {
        var re = new RegExp('^' + pat.split('*').map(escapeRegex).join('.*') + '$');
        return re.test(path);
      }
      return path === pat;
    }

    function pageAllowed(mode, rawPaths) {
      if (!mode || mode === 'all_pages') return true;
      var lines = String(rawPaths || '').split(/\r?\n|,/);
      var pathname = window.location.pathname;
      var matched = false;
      for (var i = 0; i < lines.length; i++) {
        if (pathMatches(lines[i], pathname)) {
          matched = true;
          break;
        }
      }
      if (mode === 'include_only') return matched;
      if (mode === 'exclude') return !matched;
      return true;
    }

    function freqKey(id) {
      return PREFIX + id;
    }

    function readFreq(id) {
      try {
        var raw = localStorage.getItem(freqKey(id));
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    function writeFreq(id, payload) {
      try {
        localStorage.setItem(freqKey(id), JSON.stringify(payload));
      } catch (e) {}
      try {
        sessionStorage.setItem(freqKey(id), '1');
      } catch (e) {}
    }

    function frequencyAllows(item) {
      var id = item.getAttribute('data-block-id');
      var mode = item.getAttribute('data-frequency') || 'once_per_day';
      var interval = parseInt(item.getAttribute('data-frequency-interval'), 10) || 7;
      try {
        if (sessionStorage.getItem(freqKey(id)) === '1' && mode === 'once_per_session') return false;
      } catch (e) {}
      var stored = readFreq(id);
      if (!stored || !stored.ts) return true;
      var now = Date.now();
      if (mode === 'only_once') return false;
      if (mode === 'once_per_session') {
        try {
          return sessionStorage.getItem(freqKey(id)) !== '1';
        } catch (e) {
          return now - stored.ts > 1000 * 60 * 60 * 4;
        }
      }
      if (mode === 'once_per_day') return now - stored.ts >= 1000 * 60 * 60 * 24;
      if (mode === 'every_x_days') return now - stored.ts >= interval * 1000 * 60 * 60 * 24;
      return true;
    }

    function rememberDismiss(item) {
      var id = item.getAttribute('data-block-id');
      writeFreq(id, { ts: Date.now() });
    }

    function isTouchDevice() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches || 'ontouchstart' in window;
    }

    function loadImages(item) {
      var src = item.getAttribute('data-image-src');
      if (!src) return;
      var imgs = qsa(item, '[data-popup-overlay-img]');
      imgs.forEach(function (img) {
        if (!img.getAttribute('src')) img.setAttribute('src', src);
      });
      if (item.getAttribute('data-bg-mode') === 'image_background') {
        var card = qs(item, '.popup-overlay__card');
        if (card) card.style.backgroundImage = 'url(' + src + ')';
      }
    }

    function getFocusable(container) {
      return qsa(container, 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])').filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function initRoot(root) {
      if (!root || root.getAttribute('data-popup-ready') === 'true') return;
      root.setAttribute('data-popup-ready', 'true');

      var items = qsa(root, '[data-popup-overlay-item]');
      if (!items.length) return;

      var designMode = root.getAttribute('data-design-mode') === 'true' || window.Shopify && Shopify.designMode;
      var loggedIn = root.getAttribute('data-logged-in') === 'true';
      var activeItem = null;
      var lastFocus = null;
      var keyHandler = null;
      var openTimer = null;
      var listeners = [];

      function addListener(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        listeners.push([target, type, fn, opts]);
      }

      function audienceAllows(item) {
        var audience = item.getAttribute('data-target-audience') || 'all';
        if (audience === 'all') return true;
        if (audience === 'customers_only') return loggedIn;
        if (audience === 'new_visitors') return !loggedIn && isNewVisitor();
        return true;
      }

      function itemEligible(item) {
        if (!inDateRange(item.getAttribute('data-active-from'), item.getAttribute('data-active-until'))) return false;
        if (!pageAllowed(item.getAttribute('data-page-mode'), item.getAttribute('data-page-paths'))) return false;
        if (!audienceAllows(item)) return false;
        if (!designMode && !frequencyAllows(item)) return false;
        return true;
      }

      function firstEligible() {
        for (var i = 0; i < items.length; i++) {
          if (itemEligible(items[i])) return items[i];
        }
        return null;
      }

      function close(record) {
        if (!root.classList.contains('is-open')) return;
        if (record && activeItem && !designMode) rememberDismiss(activeItem);
        root.classList.remove('is-open');
        document.documentElement.classList.remove('popup-overlay-open');
        document.body.classList.remove('popup-overlay-open');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        if (keyHandler) {
          document.removeEventListener('keydown', keyHandler);
          keyHandler = null;
        }
        window.setTimeout(function () {
          root.setAttribute('hidden', '');
          root.setAttribute('aria-hidden', 'true');
          items.forEach(function (item) {
            item.setAttribute('hidden', '');
          });
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        activeItem = null;
      }

      function trapFocus(event) {
        if (event.key !== 'Tab' || !activeItem) return;
        var wrap = qs(activeItem, '.popup-overlay__card-wrap');
        var list = getFocusable(wrap);
        if (!list.length) {
          event.preventDefault();
          return;
        }
        var first = list[0];
        var last = list[list.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function open(item) {
        if (!item || root.classList.contains('is-open')) return;
        activeItem = item;
        lastFocus = document.activeElement;
        loadImages(item);
        items.forEach(function (el) {
          if (el === item) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
        root.removeAttribute('hidden');
        root.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('popup-overlay-open');
        document.body.classList.add('popup-overlay-open');
        requestAnimationFrame(function () {
          root.classList.add('is-open');
          var closeBtn = qs(item, '.popup-overlay__close');
          var dialog = qs(item, '.popup-overlay__card');
          if (closeBtn) closeBtn.focus();
          else if (dialog) dialog.focus();
        });
        keyHandler = function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            close(true);
            return;
          }
          trapFocus(event);
        };
        document.addEventListener('keydown', keyHandler);
      }

      function bindItem(item) {
        qsa(item, '[data-popup-overlay-dismiss]').forEach(function (el) {
          el.addEventListener('click', function () {
            close(true);
          });
        });
        qsa(item, '[data-popup-overlay-cta]').forEach(function (el) {
          el.addEventListener('click', function () {
            if (!designMode) rememberDismiss(item);
          });
        });
      }

      items.forEach(bindItem);
      qs(root, '[data-popup-overlay-dismiss]') &&
        qs(root, '.popup-overlay__backdrop').addEventListener('click', function () {
          close(true);
        });

      function arm(item) {
        var mode = item.getAttribute('data-trigger-mode') || 'timer';
        var delay = Math.max(1, parseInt(item.getAttribute('data-timer-delay'), 10) || 10) * 1000;
        var fired = false;
        function fire() {
          if (fired) return;
          fired = true;
          open(item);
        }
        if (designMode) {
          fire();
          return;
        }
        if (mode === 'timer') {
          openTimer = window.setTimeout(fire, delay);
          return;
        }
        if (isTouchDevice()) {
          openTimer = window.setTimeout(fire, delay);
          var lastY = window.scrollY || 0;
          addListener(window, 'scroll', function () {
            var y = window.scrollY || 0;
            if (lastY - y > 80 && y < 80) fire();
            lastY = y;
          }, { passive: true });
          return;
        }
        addListener(document, 'mouseout', function (event) {
          if (!event.relatedTarget && event.clientY <= 0) fire();
        });
      }

      markReturningVisitor();

      if (designMode) {
        arm(items[0]);
        document.addEventListener('shopify:block:select', function (event) {
          var selected = event.target.closest('[data-popup-overlay-item]');
          if (!selected || !root.contains(selected)) return;
          if (openTimer) window.clearTimeout(openTimer);
          root.classList.remove('is-open');
          open(selected);
        });
        return;
      }

      var winner = firstEligible();
      if (winner) arm(winner);
    }

    function boot() {
      qsa(document, '[data-popup-overlay-root]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-popup-overlay-root]');
      if (root) {
        root.removeAttribute('data-popup-ready');
        initRoot(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
